import { Iterable } from 'immutable';

const requiredType = checkValue => {

const value = Iterable.isIterable(checkValue) ? checkValue.toJS(): checkValue;
   return  (value === null || value === '' || typeof value === 'undefined' || (value && value.label === null) || (value && value.label === undefined)) ? 'This field is requiredType' : undefined;
} 
export default requiredType;